<template>
    <b-list-group-item :class="eventclasses">
        <h2 v-if="event.nextevent">Nächster Termin</h2>
        <div v-for="(agenda, agenda_i) in event.event_agenda" :key="agenda_i" class="mt-3">
            <router-link v-if="event.ID" :to="{ name: 'event-detail', params: { Id: event.ID }}">
                <event-core-info :event="event" :agenda="agenda" :detailView="false"></event-core-info>
            </router-link>
        </div>
        <template v-if="event.nextevent">
            <b-row>
                <template v-if="!isActivity">
                    <b-col cols="6" style="padding-right:7px;" v-if="!event.pastevent">
                        <b-btn variant="light border" class="btn-block" v-if="event.ID" :to="{ name: 'event-detail', params: { Id: event.ID }}">Details</b-btn>
                    </b-col>
                    <b-col style="padding-left:8px" v-if="!event.pastevent">
                        <application :agenda="event.event_agenda" :event_id="event.ID"></application>
                    </b-col>
                </template>
                <template v-else>
                    <b-col style="padding-right:7px;">
                        <b-btn variant="light border" class="btn-block" :to="{ name: 'event-edit', params: { Id: event.ID }}">Bearbeiten</b-btn>
                    </b-col>
                    <b-col style="padding-left:8px; padding-right: 7px;" v-if="!event.pastevent">
                        <application :agenda="event.event_agenda" :event_id="event.ID"></application>
                    </b-col>
                    <b-col style="padding-left:8px">
                        <b-btn variant="primary" class="btn-block" :to="{ name: 'presence', params: { Id: event.ID }}">Teilnehmer</b-btn>
                    </b-col>
                </template>
            </b-row>
        </template>
    </b-list-group-item>
</template>

<script>
// import SvgIconClock from '@/components/svg-icon/Clock.vue';
// import SvgIconSocial from '@/components/svg-icon/Social.vue';
import { mapGetters } from "vuex";
import EventCoreInfoVue from './EventCoreInfo.vue';
import ApplicationVue from './Application.vue';
export default {
    name: 'event-list-item',
    components: {
        // 'svg-icon-clock': SvgIconClock,
        // 'svg-icon-social': SvgIconSocial,
        'event-core-info': EventCoreInfoVue,
        'application': ApplicationVue
    },
    props: {
        event: {
            type: Object
        }
    },
    computed: {
        isAdmin() {
            return false;
        },
        ...mapGetters('auth', ['loggedIn', 'isActivity']),
        eventclasses() {
            const eventclasses = ['event-list-item'];
            if (this.event.nextevent) {
                eventclasses.push('bg-info');
            }
            if (this.event.pastevent) {
                eventclasses.push('text-disabled');
            }
            return eventclasses.join(' ');
        }
    }
}
</script>

<style lang="scss">
@import '../scss/variables';
    .event-list-item {
        font-size: 14px;
        line-height: 1.3;

        h2 {
            font-size: 20px;
            margin: 0;
        }

        &__description {
            margin-top: 9px;
            line-height: 20px;
            margin-bottom: 15px;
            color: $black;
        }

        .badge {
            font-size: 10px;
            padding: 5px 7px 5px 8px;
            border-radius: 7px;
        }

        .btn {
            font-size: 14px;
            font-weight: $font-weight-bold;
            padding: 14px 0 13px;

            &-light {
                color: $primary;
            }
        }

        a {
            &:hover {
                text-decoration: none;
            }
        }
    }
</style>